/*** IMPORTS FROM imports-loader ***/
var define = false;

import uniqueId from 'lodash/uniqueId'
import Vue from 'vue'

const Switch = Vue.extend({
  model: {
    prop: 'checked',
    event: 'switched',
  },

  // language=HTML (for PhpStorm)
  template: `
    <div class="switch" :class="classObject">
      <input type="checkbox" :id="id" class="switch-input" v-model="realChecked">
      <label class="switch-paddle" :for="id">
        <span class="switch-active" aria-hidden="true">{{ on }}</span>
        <span class="switch-inactive" aria-hidden="true">{{ off }}</span>
      </label>
    </div>
  `,

  props: {
    size: {
      type: String,
      default: '',
    },
    on: {
      type: String,
      default: 'Yes',
    },
    off: {
      type: String,
      default: 'No',
    },
    checked: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      id: `switch-${uniqueId()}`,
      realChecked: this.checked,
    }
  },

  computed: {
    classObject() {
      const classes = {}
      if (this.size) {
        classes[this.size] = true
      }
      return classes
    },
  },

  watch: {
    checked(checked) {
      this.realChecked = checked
    },
    realChecked(checked) {
      this.$emit('switched', checked)
    },
  },
})

export default Switch

